import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, share, tap } from 'rxjs/operators';

import { BasicDataModel } from '../models/basic-data.model';
import { ActionResultModel } from '../models/core/action-result.model';
import { CacheService } from './cache.service';
import { BasicDataResource } from './resources/basic-data.resource';

@Injectable({
    providedIn: 'root'
})
export class BasicDataService {
    private currentRequest?: Observable<BasicDataModel>;

    private readonly cacheKey = 'basic-data';
    private readonly cacheService = new CacheService();

    private readonly basicDataResource = inject(BasicDataResource);

    get(): Observable<BasicDataModel> {
        const value = this.cacheService.get<BasicDataModel>(this.cacheKey);
        if (!!value) {
            return of(value);
        }

        if (!this.currentRequest) {
            this.currentRequest = this.basicDataResource.get().pipe(
                map(data => data.value),
                tap(data => {
                    this.cacheService.set(this.cacheKey, data);
                    this.currentRequest = undefined;
                }),
                share()
            );
        }

        return this.currentRequest;
    }

    update(data: BasicDataModel): Observable<ActionResultModel> {
        this.cacheService.clear(this.cacheKey);
        return this.basicDataResource.update(data);
    }
}
